<template>
<!--我的订单-->
  <div class="orders">
    <!-- <div v-show="$route.meta.navShow"> -->
      <div class="titleWrap">
        <p class="titleName">我的证书 > 全国物业行业项目经理职业资格证书</p>
      </div>
      <div class="content">
        <p class="title"><img src="../../assets/xuefenlogo.png" alt=""></p>
        <ul>
        	<li><span>兹证明</span> 王小东</li>
          <li><span>所持有的</span><p><span>全国物业行业项目经理职业资格证书</span> 具有兑换学分的资格</p></li>
          <li><span>证书编号</span> 110102295637900</li>
          <li><span>学分对应科目</span> <p>物业项目运营管理(非统设选修)</p></li>
          <li><span>学分认定证书</span><p>全国物业行业项目经理职业资格证书</p> </li>
          <li><span>认定学分</span> 5分</li>
          <li><span>认定证明有效期</span><p>2019年10月20日 <br>2019年10月20日</p> </li>
        </ul>
      </div>
      <p>
         <router-link to="/">学分认定</router-link>
        <router-link to="/" class="save" style="display: none;"><img src="../../assets/download.png" alt="" width="22">保存相册</router-link>
      </p>

  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  .titleWrap {
    height: 40px;
    font-size: 18px;
    padding-bottom: 20px;
    text-align: justify-all;
    border-bottom: 1px solid #E1E1E1;
    margin-bottom: 20px;
    color: #083C68;
    .titleName {
      float: left;
      line-height: 24px;
      padding-bottom: 13px;
    }
  }
  .content{
   background: url('../../assets/zhengshubg.png') no-repeat;
   width: 490px;
   height: 626px;
   margin:50px auto;
    padding-top: 50px;
   .title{
      font-size: 30px;
      color: #333;

      margin:35px auto;
      text-align: center;
      // width: 240px;
      font-weight: 700;
   }
   li{
      font-size: 17px;
      color: #666;
      padding:0 60px;
      margin-bottom: 12px;
      span{
        color: #000;
        display: inline-block;
        width: 135px;
      }
      p{
        width: 224px;
        vertical-align: top;
        display: inline-block;
        span{
          color: #244068;
          display: inline;
        }
      }
   }
  }
  a{
    color: #fff ;
    font-size: 16px;
    background-color: #957960;
    display: block;
    width: 220px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 5px;
    margin: auto;
    img{
      vertical-align: middle;
      margin-right: 10px;
    }
  }
.save{
  border-radius: 50px;
}



</style>
<script type="text/ecmascript-6">
  import centers from '../template/center'
    export default {
        name: 'orderdetail',
        props: {},
        data() {
            return {


            };
        },
        methods: {

        },
        created() {

        },
        components: {
          centers
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/center/xuefendetail.vue